/** The texts of a „Meinten Sie …“ row; bind them as props (`v-bind`) to translate it. */
export interface NxSuggestionRowLabels {
  /** Before the suggestion. */
  prefixLabel: string;
  /** The link that keeps what was typed, this time. */
  keepLabel: string;
  /** The link that keeps what was typed for good; `{original}` is replaced by it. */
  confirmLabel: string;
  /** The opt-in link that stops suggesting the suggested word; `{text}` is replaced by it. */
  neverSuggestLabel: string;
}

/** The English texts: `<NxSuggestionRow v-bind="NX_SUGGESTION_ROW_LABELS_EN" … />`. */
export const NX_SUGGESTION_ROW_LABELS_EN: Readonly<NxSuggestionRowLabels> = {
  prefixLabel: 'Did you mean',
  keepLabel: 'Ignore',
  confirmLabel: '"{original}" is correct',
  neverSuggestLabel: 'Stop suggesting "{text}"',
};
